<nb-card class="print-layout" [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <ngx-view-customer
      [customer]="customer"
      [mode]="'dept'"
    ></ngx-view-customer>

    <div class="summary">
      <div>
        <ngx-view-time-period
          (periodChange)="selectTime($event)"
          [typeSelected]="'thisMonth'"
          [allowAll]="
            user.moderator ||
            user.admin ||
            (shopService.shop.isArchived && shopService.shop.shopIdArchived)
          "
        ></ngx-view-time-period>

        <nb-checkbox
          [(ngModel)]="isDetail"
          [status]="isDetail ? 'danger' : 'primary'"
        >
          <span *ngIf="isDetail" class="text-primary link">Chi tiết</span>
          <span *ngIf="!isDetail" class="text-danger link">Tổng hợp</span>
        </nb-checkbox>
      </div>

      <!-- <ngx-card-value-overview
        *ngIf="initAmount != 0"
        [title]="'Đầu kỳ'"
        [value]="initAmount"
        [type]="'primary'"
        [icon]="'activity-outline'"
      >
      </ngx-card-value-overview> -->

      <ngx-card-value-overview
        [title]="'Doanh thu'"
        [value]="displaySaleAmount"
        [type]="'primary'"
        [icon]="'trending-up-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'Thanh toán'"
        [value]="displayPaidAmount"
        [type]="'success'"
        [icon]="'arrow-circle-up-outline'"
      >
      </ngx-card-value-overview>

      <ngx-card-value-overview
        [title]="'PS nợ'"
        [value]="displayDebitAmount"
        [type]="'warning'"
        [icon]="'alert-circle-outline'"
      >
      </ngx-card-value-overview>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Loại</th>
            <th scope="col">Số phiếu</th>
            <th scope="col">Ngày</th>
            <th *ngIf="isDetail" scope="col">Mô tả</th>
            <th scope="col">PS Tăng</th>
            <th scope="col">Đã thanh toán</th>
            <th scope="col">Còn nợ</th>
            <th scope="col">Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of displayDebits; let i = index">
            <td class="col-no">
              {{ i + 1 }}
            </td>
            <td>
              {{
                item.mode === "receipt"
                  ? "Bán hàng"
                  : item.mode === "purchase"
                    ? "Mua hàng"
                    : "Thanh toán"
              }}
            </td>
            <td>
              <a (click)="viewDetail(item)" class="link text-link">
                <nb-icon icon="more-horizontal-outline"></nb-icon>
                {{ item.code }}
              </a>
            </td>
            <td>
              <span *ngIf="item.code !== 'Đầu kỳ'">
                {{ item.issueDate | date: "dd/MM/yyyy" }}
              </span>
            </td>

            <td *ngIf="isDetail">
              <div *ngIf="item.mode === 'payment'">
                <ul class="detail">
                  <li *ngIf="item.payment.personName">
                    <label class="label">
                      Người nộp:
                      <span class="text-body">
                        {{ item.payment.personName }}
                      </span>
                    </label>
                  </li>
                  <li *ngIf="item.payment.personMobile">
                    <label class="label">
                      ĐT:
                      <span class="text-body">
                        {{ item.payment.personMobile }}
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
              <div
                *ngIf="item.mode === 'receipt' && item.code !== 'Đầu kỳ'"
                class="table-responsive"
              >
                <table class="table table-striped">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Mã hàng</th>
                      <th scope="col">Tên hàng</th>
                      <th scope="col">ĐVT</th>
                      <th scope="col" class="col-number">Đơn giá</th>
                      <th scope="col" class="col-number">Số lượng</th>
                      <th scope="col" class="col-number">$ giảm</th>
                      <th scope="col" class="col-number">Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let itemDetail of item.receipt.receiptDetails;
                        let i = index
                      "
                    >
                      <td class="col-no">
                        {{ i + 1 }}
                      </td>
                      <td>
                        {{ itemDetail.productCode }}
                      </td>
                      <td>
                        {{ itemDetail.productName }}
                        <span *ngIf="itemDetail.comment"
                          >( {{ itemDetail.comment }} )</span
                        >
                      </td>
                      <td>
                        {{ itemDetail.productUnitName }}
                      </td>
                      <td class="col-number">
                        {{ itemDetail.price | number }}
                      </td>
                      <td class="col-number">
                        {{ itemDetail.quantity | number }}
                      </td>
                      <td class="col-number">
                        <span *ngIf="itemDetail.discountPercent > 0"
                          >{{ itemDetail.discountPercent }}% :</span
                        >
                        {{ itemDetail.discountAmount | number }}
                      </td>
                      <td class="col-number">
                        <strong>{{ itemDetail.amount | number }}</strong>
                      </td>
                    </tr>
                  </tbody>

                  <tfoot>
                    <tr>
                      <td class="col-label" colspan="5">
                        <strong class="text-hint">Tổng cộng</strong>
                      </td>
                      <td class="col-number">
                        <strong class="text-primary">
                          {{ item.receipt.totalQuantity | number }}
                        </strong>
                      </td>
                      <td></td>
                      <td class="col-number">
                        <strong class="text-primary">
                          {{ item.receipt.detailAmount | number }}
                        </strong>
                      </td>
                    </tr>

                    <tr *ngIf="item.receipt.discountAmount > 0">
                      <td class="col-label" colspan="5">
                        <strong class="text-hint">Chiết khấu</strong>
                      </td>
                      <td colspan="3" class="col-number">
                        <strong class="text-primary">
                          {{ item.receipt.discountAmount | number }}
                        </strong>
                      </td>
                    </tr>

                    <tr
                      *ngIf="
                        item.receipt.totalAmount !== item.receipt.detailAmount
                      "
                    >
                      <td class="col-label" colspan="5">
                        <strong class="text-hint">Thành tiền</strong>
                      </td>
                      <td colspan="3" class="col-number">
                        <strong class="text-primary">
                          {{ item.receipt.totalAmount | number }}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </td>
            <td class="col-number">
              {{ item.amount | number }}
            </td>
            <td class="col-number">
              {{ item.paid | number }}
            </td>
            <td class="col-number">
              {{ item.debit | number }}
            </td>
            <td>
              {{ item.note }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      outline
      status="primary"
      size="small"
      (click)="newReceipt()"
    >
      <nb-icon icon="shopping-cart-outline"></nb-icon>
      Bán hàng
    </button>

    <button
      nbButton
      outline
      status="success"
      size="small"
      (click)="newPayment(true)"
    >
      <nb-icon icon="arrow-circle-up-outline"></nb-icon>
      Thu nợ
    </button>

    <button
      nbButton
      outline
      status="default"
      size="small"
      (click)="newPayment(false)"
    >
      <nb-icon icon="arrow-circle-down-outline"></nb-icon>
      Chi nợ
    </button>

    <button
      nbButton
      outline
      status="warning"
      size="small"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      In
    </button>

    <button
      nbButton
      outline
      status="info"
      size="small"
      (click)="exportAsXLSX()"
    >
      <nb-icon icon="download-outline"></nb-icon>
      {{ "buttons.downloadExcel" | translate }}
    </button>

    <button nbButton outline status="danger" size="small" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
